import { useMutation } from "@tanstack/react-query";
import { fetchSampleResponsePreviewHtml } from "../api/rfx-report-api";
import type { RfxResponsePreviewParams, RfxReportPreviewHtmlResponse } from "../types";

export const useSampleResponsePreviewHtml = () => {
	return useMutation<RfxReportPreviewHtmlResponse, Error, RfxResponsePreviewParams>({
		mutationFn: (params) => fetchSampleResponsePreviewHtml(params),
	});
};
